import { defineStore } from 'pinia'
import type { measurementType } from '@/types/measurement'
import { bikeType, bikeSetup, BikeHoodsType } from '@/types/bike'
import bikeService from '@/service/bikeService'
import { PreviewImage } from '@/types/preview'

export const useBikeStore = defineStore('bikeStore', {
  state: (): {
    bikeNo: number
    bikeData?: bikeType
    bikeSetup?: bikeSetup
    bikeFinalSetup?: bikeSetup
    bikeHoodsType: BikeHoodsType
    bikePreview: PreviewImage
  } => ({
    bikeNo: 0,
    bikeData: undefined,
    bikeSetup: undefined,
    bikeFinalSetup: undefined,
    bikeHoodsType: BikeHoodsType.DROPBAR,
    bikePreview: PreviewImage.DROPBAR_BIKE,
  }),
  getters: {},
  actions: {
    async retrieveBikes(
      customerId: string,
      dealerId: string,
      sessionId: string,
    ) {
      const { data } = await bikeService.fetchBikes({
        customerId: customerId,
        bikeNo: this.bikeNo,
        dealerId: dealerId,
        sessionId: sessionId,
      })

      if (data.Bikes.length === 1) {
        this.bikeData = data.Bikes[0]
      }

      return data
    },

    async updateXY(
      customerId: string,
      dealerId: string,
      sessionId: string,
      measurement: measurementType,
      final: boolean,
    ) {
      const { data } = await bikeService.putXY({
        customerId: customerId,
        bikeNo: this.bikeNo,
        dealerId: dealerId,
        sessionId: sessionId,
        measurement: measurement,
      })

      if (data.BikeSetup) {
        if (final) {
          this.bikeFinalSetup = data.BikeSetup
        } else {
          this.bikeSetup = data.BikeSetup
        }
      }

      return data
    },
  },
  persist: {
    storage: sessionStorage,
  },
})
